import HTMLTemplate from './template.html'
import './styles.scss'
import tippy, { followCursor } from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/shift-away.css'
import { EventFilter } from '../EventFilter/EventFilter'
import InternationalSOSAlerts from '../../modules/InternationalSOSAlerts'
import AvsecAlerts from '../../modules/avsecAlerts'
import User from '../../modules/user'
import { TutorialComponent } from '../Tutorial/Tutorial'
import { debounce } from 'lodash'
import { Settings } from './../../components/Settings/Settings'
import { SearchBar } from './../../components/SearchBar/SearchBar'
import MaritimeAlerts from '../../modules/maritimeAlerts'
import { ApplicationInfoModalComponent } from '../ApplicationInfo/ApplicationInfo'
import { LogoutModalComponent } from '../Logout/Logout'

export const AlertsBar = (() => {
    const vueComponent = {
        data() {
            return {
                activeDropDownFirst: '',
                activeDropDown: '',
                displayAlerts: false,
                userName: '',
                userEmail: '',
                activeSettingsSection: 'General',
                alertFilters: {},
                maritimeFilters: {
                    enabled: true
                },
                enableAvsecAlerts: false,
                lastLiveEventHeadline: '',
                lastLiveEventType: '',
                lastLiveAviationAlertStatus: '',
                lastLiveMaritimeAlertTypeId: '',
                hasLoadedAlerts: false,
                showSettingsDropdown: false,
                enableHelpSection: true,
                enableAviationFeatures: false,
                enableMaritimeFeatures: false
            }
        },
        created() {
            document.getElementById('app-loading-screen').classList.add('has-top-bar')
            User.getUserPermissions().then(permissions => {
                
                if (permissions.includes('luxury_yachting')) {
                    MaritimeAlerts.getCurrentAlertsAvailableCategories().then(maritimeFilters => {
                        this.maritimeFilters = maritimeFilters
                    })
                }
            })

            User.getLocalUserInfo().then(user => {
                this.userName = user.name
                this.userEmail = user.email

                const userFilters = JSON.parse(user.settings.filters)
                this.displayAlerts = userFilters.enableAlerts
                this.enableAvsecAlerts = userFilters.enableAviationAlerts
            })

            InternationalSOSAlerts.getCurrentAlertsAvailableCategories().then(alertFilters => {
                this.alertFilters = alertFilters
                window.setTimeout(() => this.hasLoadedAlerts = true, 1000)
            })

            // Hide top dropdowns if user clicks anywhere outside
            document.body.addEventListener('click', (event) => {
                if (event.target.closest('.js-ignore-child-target') === null) {
                    this.activeDropDown = ''
                    this.activeDropDownFirst = ''
                }
            })
        },
        methods: {
            showAlertFlyout() {
                document.getElementsByClassName('app-template')[0].classList.add('event-panel-show')
            },
            toggleDropDownFirst(dropdownID) {
                this.activeDropDownFirst = this.activeDropDownFirst === dropdownID ? '' : dropdownID
                SearchBar.showMobileDropdownFilters = false
                // @Adam I need to check with you how best to handle this 
                // Settings.showSettings = false
                // Settings.restartSettingsState()
            },
            toggleDropDown(dropdownID) {
                this.activeDropDown = this.activeDropDown === dropdownID ? '' : dropdownID
                SearchBar.showMobileDropdownFilters = false
            },
            debounceUpdateUserSettings: debounce(function () {
                this.updateUserSettings()
            }, 500),
            updateUserSettings() {
                User.getLocalUserSettings().then(settings => {
                    let updatedUserSettings = settings
                    let userFilters = JSON.parse(settings.filters)
                    userFilters.enableAviationAlerts = this.enableAvsecAlerts

                    // Update also main categories to see if they were enabled or not
                    for (const key in this.alertFilters) {
                        if (userFilters.alertFilters[key] !== undefined) {
                            userFilters.alertFilters[key].enabled = this.alertFilters[key].enabled
                        }
                    }

                    userFilters.maritimeFilters.enabled = this.maritimeFilters.enabled

                    updatedUserSettings.filters = JSON.stringify(userFilters)
                    User.updateUserSettings(updatedUserSettings)
                })
            },
            showFilters() {
                EventFilter.$data.enableAvsecAlerts = this.enableAvsecAlerts
                EventFilter.$data.enableAlerts = this.displayAlerts
                EventFilter.$data.alertFilters = this.alertFilters
                EventFilter.$data.enableAviationFeatures = this.enableAviationFeatures
                EventFilter.$data.enableMaritimeFeatures = this.enableMaritimeFeatures

                EventFilter.show()
            },
            maritimeFilterAlerts() {
                MaritimeAlerts.filter(this.maritimeFilters, EventFilter.$data.timeFrame)
                this.debounceUpdateUserSettings()
            },
            filterAlerts() {
                InternationalSOSAlerts.filter(this.alertFilters, EventFilter.$data.timeFrame, EventFilter.$data.alertSeverities)

                if (this.displayAlerts) {
                    if (this.enableAviationFeatures) {
                        this.enableAvsecAlerts ? AvsecAlerts.show() : AvsecAlerts.hide()
                    }

                    this.debounceUpdateUserSettings()
                } else {
                    // If the alerts in general are disabled, it's fine, but we still want to save user preference on that in his settings
                    this.debounceUpdateUserSettings()
                }
            },
            showSettings() {
                Settings.showSettings = true
            },
            showHelp() {
                TutorialComponent.showHelp()
            },
            showAppInfo() {
                document.getElementsByClassName('app-template')[0].classList.add('show-application-modal')
            },
            hideAppInfo() {
                document.getElementsByClassName('app-template')[0].classList.remove('show-application-modal')
            },
            showLogoutConfirmation() {
                LogoutModalComponent.$data.show = true
            },
            showApplicationInfo() {
                ApplicationInfoModalComponent.$data.show = true
            }
        },
        watch: {
            'displayAlerts': function () {
                if (this.hasLoadedAlerts) {
                    if (this.displayAlerts) {
                        InternationalSOSAlerts.show()
                        if (this.enableMaritimeFeatures) {
                            MaritimeAlerts.show()
                        }

                        if (this.enableAviationFeatures && this.enableAvsecAlerts) {
                            AvsecAlerts.show()
                        }
                    } else {
                        InternationalSOSAlerts.hide()
                        if (this.enableMaritimeFeatures) {
                            MaritimeAlerts.hide()
                        }
                        if (this.enableAviationFeatures) {
                            AvsecAlerts.hide()
                        }
                    }
                }
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-alerts-bar')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).use({
            install: (app) => {
                app.directive('tooltip', {
                    beforeMount(el, binding) {
                        tippy(el, {
                            content: binding.value,
                            placement: 'bottom-start',
                            animation: 'shift-away',
                            allowHTML: true,
                            trigger: 'mouseenter',
                            arrow: false,
                            followCursor: true,
                            plugins: [followCursor]
                        })
                    }
                })
            }
        }).mount(DOMElement)
    }
})()
